module.exports = __webpack_public_path__ + "static/media/icon_circle-cfa-logo-small.4072d6cf.png";